import { render, staticRenderFns } from "./CreaLavorazione.vue?vue&type=template&id=1449f6f4&scoped=true"
import script from "./CreaLavorazione.vue?vue&type=script&lang=js"
export * from "./CreaLavorazione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1449f6f4",
  null
  
)

export default component.exports